import moment from 'moment';
import { Document, Inventory } from 'lib/documents';
import { IHandleError } from 'lib/utils/redux';
import { AssessmentType } from 'lib/documents/patient-assessment/patient-assessment';

export interface PendingAssessmentData extends Document {
  expirationDate: moment.Moment;
  assessmentType: AssessmentType;
}

export interface QuestionnaireControlFlowState extends IHandleError {
  /**
   * Number of questionnaires that need to be completed
   */
  required: number;
  /**
   * Number of questionnaires that are completed
   */
  fulfilled: number;
  data: Partial<Record<(typeof QuestionnaireTestNames)[number], Inventory>>;
  order: string[];
  /**
   * A map of which tests are completed.
   * - Key - The test name
   * - Value - `true` if the test was completed. `false` otherwise
   */
  done: Record<string, boolean>;
  /**
   * `true` if the user completed all the tests. `false` otherwise
   */
  allDone: boolean;
  current?: string;
  assessmentData: PendingAssessmentData | null;
} //reducer to fulfill

/**
1. check last 30 days entries of valid entries of
- promis
- dhi
- cgs
- pcs
*/
export const QuestionnaireTestNames = [
  'promis',
  'cgs',
  'pcs',
  'dhi',
  'impact'
] as const;
